// BusinessBrands.js
import Image from "next/image";

const BusinessBrands = () => {
  const brands = [
    {
      name: "Uber",
      logo: "https://d31bwppm8yl9g2.cloudfront.net/learner/website/gsb1.svg",
      mobileWidth: 60,
      mobileHeight: 60,
      desktopWidth: 104,
      desktopHeight: 104,
    },
    {
      name: "Shiprocket",
      logo: "https://d31bwppm8yl9g2.cloudfront.net/learner/website/gsb2.svg",
      mobileWidth: 60,
      mobileHeight: 60,
      desktopWidth: 104,
      desktopHeight: 104,
    },
    {
      name: "Domino's",
      logo: "https://d31bwppm8yl9g2.cloudfront.net/learner/website/gsb3.svg",
      mobileWidth: 97,
      mobileHeight: 60,
      desktopWidth: 157,
      desktopHeight: 104,
    },
    {
      name: "Aditya Birla Group",
      logo: "https://d31bwppm8yl9g2.cloudfront.net/learner/website/gsb4.svg",
      mobileWidth: 60,
      mobileHeight: 60,
      desktopWidth: 104,
      desktopHeight: 104,
    },
    {
      name: "Shell",
      logo: "https://d31bwppm8yl9g2.cloudfront.net/learner/website/gsb5.svg",
      mobileWidth: 109,
      mobileHeight: 60,
      desktopWidth: 180,
      desktopHeight: 104,
    },
    {
      name: "Tata Communications",
      logo: "https://d31bwppm8yl9g2.cloudfront.net/learner/website/gsb6.svg",
      mobileWidth: 60,
      mobileHeight: 60,
      desktopWidth: 104,
      desktopHeight: 104,
    },
    {
      name: "Adobe",
      logo: "https://d31bwppm8yl9g2.cloudfront.net/learner/website/gsb7.svg",
      mobileWidth: 60,
      mobileHeight: 60,
      desktopWidth: 104,
      desktopHeight: 104,
    },
  ];

  return (
    <div className="w-full pb-10 sm:py-10">
      <div className="w-[90%] sm:w-4/5 mx-auto">
        <div className="mb-8">
          <h3 className="text-base font-medium">Brands in Collaboration</h3>
        </div>

        {/* Mobile Layout: 4 columns for first row, 3 for second row */}
        <div className="block md:hidden">
          {/* First row - 4 brands */}
          <div className="flex justify-start gap-4 items-start mb-4">
            {brands.slice(0, 4).map((brand, index) => (
              <div
                key={index}
                className="h-[60px] relative flex items-start  justify-start"
              >
                <Image
                  src={brand.logo}
                  alt={brand.name}
                  width={brand.mobileWidth}
                  height={brand.mobileHeight}
                  style={{ objectFit: "contain" }}
                  priority={false}
                  loading="lazy"
                />
              </div>
            ))}
          </div>

          {/* Second row - 3 brands */}
          <div className="flex justify-start gap-4 items-start">
            {brands.slice(4, 7).map((brand, index) => (
              <div
                key={index + 4}
                className=" h-[60px] relative flex items-start  justify-start"
              >
                <Image
                  src={brand.logo}
                  alt={brand.name}
                  width={brand.mobileWidth}
                  height={brand.mobileHeight}
                  style={{ objectFit: "contain" }}
                  priority={false}
                  loading="lazy"
                />
              </div>
            ))}
          </div>
        </div>

        {/* Desktop Layout: Single row with all brands */}
        <div className="hidden md:flex gap-6 md:justify-start  md:items-start">
          {brands.map((brand, index) => (
            <div
              key={index}
              className=" h-[104px] relative flex items-start  justify-start"
            >
              <Image
                src={brand.logo}
                alt={brand.name}
                width={brand.desktopWidth}
                height={brand.desktopHeight}
                style={{ objectFit: "contain" }}
                priority={false}
                loading="lazy"
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default BusinessBrands;
